import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/roundnet/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/roundnet/leagues/" />;
}
